import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE, VALUE_ENTER, VALUE_ESCAPE, WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import {
  GridDNDConfig,
  PopUpManager,
  WizBaseCollector,
  WizBasePopUp,
  WizDatasource,
  WizDropdown,
  WizHgroup,
  WizIcon,
  WizPopUp,
  WizValidationContainerDirective,
  WizValidationError,
  WizVgroup,
  WizActionObj,
  WizTabButton,
  WizTabBar,
  WizEventManager, WizEvent,
} from '@wizeoo/akm-component-lib';
import { GridOptions } from 'ag-grid-community';
import { ColDef } from 'ag-grid-community';
import { WidgetConfigurationObj } from '@wizeoo/akm-message-lib';
import { FIELD_KIND } from '@wizeoo/akm-compute-lib';
import { clone } from 'lodash-es';

import { PivotField } from '../../../../../manager/baselines/pivot-field.obj';
import { PivotFunction } from '../../../../../manager/baselines/pivot-function.obj';
import { IWidget } from '../../../../../manager/widgets/i-widget';
import { StyleEngine } from '../../../../../manager/workingdata/style.engine';
import { WIDGET_GLOBAL_KIND, WIDGET_KIND } from '../../../../../model/enums';
import { Model } from '../../../../../model/model';
import { ViewData } from '../../../../../model/view.data';
import { ColorPickerPop } from '../../../../colorpicker/color-picker.pop';
import { FreedataArgsVO } from  '../../../../../vo/core/freedataargs.vo';
import { FeiVO } from '../../../../../vo/workingdata/fei.vo';
import { FormatVO } from '../../../../../vo/workingdata/format.vo';
import { StyleVO } from '../../../../../vo/workingdata/style.vo';
import { HeaderEditStyleSubPop } from './header-edit-style.sub.pop';
import { FakeVO } from '../../../../../vo/common/tool/fake.vo';
import { AggregateEngine } from '../../../../../manager/computer/aggregate-engine';
import { CssRenderVO } from '../../../../../vo/workingdata/cssrender.vo';

/** contrat d'interface pour les données manipulée dans cette PopUp */
export interface widgetHeaderVO {
  popReference: WizPopUp; // cette popUp, pour redimensionnement
  fei: FeiVO; // les données
  context: WidgetConfigurationObj; // la configuration
  updateCallback: Function; // la callback pour retour et traitement dans la popUp d'édition du pivot
  pivotField: PivotField; // le champ de configuration
  popUpMode?: WIDGET_KIND; // le mode de la popUp d'appel
  widget?: IWidget; // le pivot source pour prise en compte du mode "conf"
  baseCollector?: WizBaseCollector; // la liste source depuis le panneau de settings
  currentGroups?: PivotField[];
  place?: string; // emplacement source de la colonne
  actualWidth?: number; // largeur actuelle. Peut être différente de la largeur dans le champ de configuration
}


@Component({
  // popUp d'édition des champs de pivot: style, label, méthode d'aggrégat
  selector: 'header-editext-pop',
  templateUrl: './header-editext.pop.html',
})
export class HeaderEditExtPop extends WizBasePopUp {
  
  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
   
    if (event.key === VALUE_ENTER) {
      event.stopImmediatePropagation();
      event.preventDefault();
      this.save();
    }
    if (event.key === VALUE_ESCAPE) {
      event.stopImmediatePropagation();
      event.preventDefault();
      this.doCancel();
    }
  }  
  
  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  /** Zone de detail (pour updateEvent) */
  @ViewChild('vgDetailZone', { read: WizVgroup }) vgDetailZone: WizVgroup;
  /** barre de navigation */
  @ViewChild('tabBar', { read: WizTabBar, static: true }) tabBar: WizTabBar;


  @ViewChild('gpColumn', { read: WizVgroup }) gpColumn: WizVgroup; // zone colonnes
  @ViewChild('gpColumn', { read: WizValidationContainerDirective }) private gpColumnValidator: WizValidationContainerDirective; // validateur des champs de saisie des colonnes

  @ViewChild('blockFont') blockFont: ElementRef; // zone de dessin de la couleur de font
  @ViewChild('blockBack') blockBack: ElementRef; // zone de dessin de la couleur de background

  // @ViewChild('ddFunc', { read: WizDropdown }) ddFunc: WizDropdown; // drop de choix de la fonction
  // @ViewChild('ddFormat', { read: WizDropdown }) ddFormat: WizDropdown; // drop de choix du formatage
  @ViewChild('ddField', { read: WizDropdown }) ddField: WizDropdown; // drop de choix du champ de label des FDVs
  @ViewChild('ddChronoField', { read: WizDropdown }) ddChronoField: WizDropdown; // drop de choix du champ de label des Chronos

  @ViewChild('cellColors', { read: WizHgroup }) cellColors: WizHgroup; // groupe de la zone de dessin
  @ViewChild('cellBlockFont') cellBlockFont: ElementRef; // zone de dessin de la couleur de font
  @ViewChild('cellBlockBack') cellBlockBack: ElementRef; // zone de dessin de la couleur de background
  
  
  @ViewChild('ddStyle', { read: WizDropdown }) ddStyle: WizDropdown; // drop de choix du style
  @ViewChild('ddStyleConso', { read: WizDropdown }) ddStyleConso: WizDropdown; // drop de choix du style pour les lignes de conso
  @ViewChild('btEditStyle', { read: WizIcon }) btEditStyle: WizIcon; // bouton update du style

  @ViewChild('ddCssStyle', { read: WizDropdown }) ddCssStyle: WizDropdown; // drop de choix du style


  // @ViewChild('ddTotalFunc', { read: WizDropdown }) ddTotalFunc: WizDropdown; // drop de choix de la fonction
  // @ViewChild('ddTotalFormat', { read: WizDropdown }) ddTotalFormat: WizDropdown; // drop de choix du formatage

  public model: Model;

  /* ##############################################################################
          prises de tailles
  ############################################################################## */

  public static baseHeight: number = 500; // hauteur avec tout, statique pour prise externe sur ouverture
  public static baseWidth: number = 500; // largeur, statique pour prise externe sur ouverture

  /* ##############################################################################
                  paramètres d'affichage
  ############################################################################## */

  headTab: boolean = false;
    useHeaderTextAlign:boolean = false; // alignement du texte, uniquement GRID et PIVOT en row / col / data
    useColumn:boolean = false; // groupe resize taille & taille min, , uniquement GRID et PIVOT en row / filter / data
    isFilter: boolean = false; // utilisation du groupe colonne pour taille de filtre
    useHeaderGroup:boolean = false; // groupe de colonnes, seulement si un groupe, GRID et PIVOT en row / data 
    useHeaderColors:boolean = false;
    usePivotHeaderColors: boolean = false; // champ couleur pour pivot.header
    useHeaderInherit: boolean = false; // héritage du style de la colonne parente

  contentTab: boolean = false;
    useFormatReadonly:boolean = false; // champ en readOnly
    useMassEditSplit:boolean = false; // massEdit en mode split
    // champs chronos ou FDV
    useKey:boolean = false;
      useFormatField:boolean = false; // champ sur le FDV
      useFormatSubField:boolean = false;// sous-champ sur FDV
      useFormatChronoField:boolean = false; // champ sur le chronocode
    
    useAggregate:boolean = false; // dropdown de méthode d'aggrégat en mode pivot SANS affichage des lignes
    useFormat:boolean = true; // format de données, toujours sauf timeline
    useStyle:boolean = false; // rendu des cellules (statique et dynamique)
    useStyleMeasure:boolean = false; // rendu des cellules par une mesure (timeline)

  totalTab: boolean = false;

  filterTab: boolean = false;
    useHeaderHideFilter:boolean = false; //filtre, filtre masqué
      useHeaderOnlyExist:boolean = false; // filtre, seulement l'existant
    useSearchFields:boolean = false; // champs complémentaires pour la recherche
  
  useCssStyle:boolean = false; // style des filtres

  advancedTab: boolean = false;

  /**
   * activer la zone de saisie de mesure custom sur mode d'aggrégat COMPUTE
   */
  public get totalModeCompute(): boolean {
    return this.totalTab && this.totalFunctionDS?.selectedItem?.code === AggregateEngine.AGG_COMPUTE;
  }

  /* ##############################################################################
                données
  ############################################################################## */

  /** la DS des fonctions d'aggrégat POUR LES TOTAUX */
  public totalFunctionDS: WizDatasource<PivotFunction> = new WizDatasource<PivotFunction>([])
    .setFilter(this.totalDataKindFilter.bind(this))
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .build();

  /** DS de la drop des formats  POUR LES TOTAUX */
  public totalFormatDS: WizDatasource<FormatVO> = new WizDatasource<FormatVO>([])
    .setFilter(this.totalDataFormatFilter.bind(this))
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** la DS des fonctions d'aggrégat */
  public functionDS: WizDatasource<PivotFunction> = new WizDatasource<PivotFunction>([])
    .setFilter(this.dataKindFilter.bind(this))
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .build();

  /** DS de la drop des formats */
  public formatDS: WizDatasource<FormatVO> = new WizDatasource<FormatVO>()
    .setFilter(this.dataFormatFilter.bind(this))
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** DS de la drop des champs de rendu pour les FDVs */
  public fieldDS: WizDatasource<FreedataArgsVO> = new WizDatasource<FreedataArgsVO>([])
    // .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
    
    .setSelectionMode('single')
    .build();

  /** DS de la drop des champs de rendu pour les Chronos */
  public chronoFieldDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>([])
    .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
    //.setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .setSelectionMode('single')
    .build();


  /** la DS des styles */
  public styleDS: WizDatasource<StyleVO> = new WizDatasource<StyleVO>([])
    .setItemCodeField('fullCode')
    .setSortFields([{ property: 'fullCode', way: 'asc', numeric: false }])
    .build();

  /** la DS des styles pour les lignes de conso */
  public styleDSConso: WizDatasource<StyleVO> = new WizDatasource<StyleVO>([])
    .setItemCodeField('fullCode')
    .setSortFields([{ property: 'fullCode', way: 'asc', numeric: false }])
    .build();

  /** DS du grid des champs de sélection pour les FDVs */  
  public fieldsDS: WizDatasource<FreedataArgsVO> = new WizDatasource<FreedataArgsVO>([])
    .setSortFn(this.sortSelectedFirst.bind(this))
    // .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .setSelectionMode('multiple')
    .build();

  /** DS du sous-champ pour les FDVs */  
  public subFieldDS: WizDatasource<FreedataArgsVO> = new WizDatasource<FreedataArgsVO>([])
  .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
  .setSelectionMode('single')
  .build();
  

  /** DS groupes de colonnes */  
  public groupDS: WizDatasource<PivotField> = new WizDatasource<PivotField>([])
    .setSelectionMode('single')
    .build();

  /** DS alignement des entêtes */
  public headerAlignDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>([])
    .setSortFields([{ property: 'order', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** DS de la drop des styles */
  public cssStyleDS: WizDatasource<CssRenderVO> = new WizDatasource<CssRenderVO>([])
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();



  // champs complémentaires pour affichage des drops
  public searchFields: string[] = []; 

  // colonne du grid des champs complémentaires
  columns: ColDef[] = [
    { headerName: '$.field.shortcode.$', dndSource: true, flex: 1, sortable: true, field: 'trsLabel' }
  ];
  gridOptions: GridOptions = {
  };

  // configuration du drag sur la liste des champs de sélection
  dndConfig: GridDNDConfig<FreedataArgsVO> = {
    dragEnabled: true,
    dropEnabled: true,
    dropAction: 'reorder'
  };


  /* ##############################################################################
          éléments de cycle de vie & cycle de vie
  ############################################################################## */
  public declare datas: widgetHeaderVO; // le contrat de données pour la pop
  public clone: PivotField = null; // le clone de travail
  public arg: FreedataArgsVO; // le arg en cours

  public show(): void {
    super.show();

    this.model = this.datas.fei.model;

    this.totalFunctionDS.setSource([...this.model.aggregateEngine.functionMap().values()]);
    this.functionDS.setSource([...this.model.aggregateEngine.functionMap().values()]);
    if(!!this.model.formatEngine.getFormatList()) {
      this.totalFormatDS.setSource([...this.model.formatEngine.getFormatList()]);
      this.formatDS.setSource([...this.model.formatEngine.getFormatList()]);
    }
    this.chronoFieldDS.setSource(this.model.chronocodeEngine.getChronoFields());
    this.headerAlignDS.setSource([...ViewData.getInstance().textAlignList]);
    if(!!this.model.styleList) {
      this.styleDS.setSource([...this.model.styleList]);
      this.styleDSConso.setSource([...this.model.styleList]);
    }
      
    // TODO filter à la BU
    if(!!this.model.styleEngine.getCssRenderList()) {
      this.cssStyleDS.setSource(this.model.styleEngine.getCssRenderList());
    }



    this.clone = clone(this.datas.pivotField);
    this.manageTabs();
    this.manageVisibility();
    this.feed(); // alimentation des données et DS
    this.addListeners();
  }

  public titleLabel: string = null; // titre de la popUp
  public contentLabel: string = null; // libellé du contenu

  private stylePop: WizPopUp; // la popUp d'édition des styles
  protected doSaveFlag: boolean = true; // marqueur de validation des modifs (false sur cancel)

  public customHeaderTitle: string = null; // override du titre de la colonne
  public hideFilter: boolean = false; // masquer le filtre
  public mandatoryFilter: boolean = false; // filtre obligatoire
  public onlyExist: boolean = false; // afficher uniquement les valeurs dispo

  colWidth: number = null; // taille de la colonne
  colMinWidth: number = null; // taille min
  colResize: boolean = true; // resize autorisé
  colAuto: boolean = false; // flex = 1
  exportable: boolean = true; // pas inclus dans l'export
  hidden: boolean = false; // colonne masquée

  public readOnly: boolean = false; // champ en readOnly
  public massEditSplit: boolean = false; // mode split sur massEdit
  /** activation du bouton d'édition des styles */
  public get editStyleEnabled(): boolean {
    return !!this.styleDS?.selectedItem;
  }

  /** gestion des styles */
  public get mayEditStyle(): boolean {
    return this.datas?.widget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.BASELINE;
  }

  /** gestion des styles pour les lignes de conso */
  public get mayEditStyleConso(): boolean {
    let isPivot = this.datas?.widget?.widgetKind === WIDGET_KIND.PIVOT;
    let pmd = this.datas.context.pmdex === true;
    let place = this.datas.baseCollector?.id === 'lstRow' || this.datas.place === 'row';
    return isPivot && pmd && place;
  }

  /**
   * activation de la colonne taille min
   */
  public get resizeEnabled(): boolean {
    return this.clone?.colRezisable
  }

  // styles de headers
  public fontColor = 'unset'; // StyleEngine.STYLE_DEFAULT_FONT_COLOR; // --grid-header-color
  public backgroundColor = 'unset'; // StyleEngine.STYLE_DEFAULT_BACKGROUND_COLOR; // --grid-header-background-color
  public css: any = null;
  public headColorField: string = null;
  public headSubField: string = null;
  public headInherit: boolean = false;

  // styles de cellules
  public cellFontColor = StyleEngine.STYLE_DEFAULT_CELL_FONT_COLOR; // --grid-header-color
  public cellBackgroundColor = StyleEngine.STYLE_DEFAULT_CELL_BACKGROUND_COLOR; // --grid-header-background-color
  public isBold: boolean = false; // gras pour les cellules
  public cellCss: any = null;

  // alimentation du style par une mesure (cas timeline). On va recycler hsty
  public fontMeasure: string = null;
  public backMeasure: string = null;

  // mesure custom pour les aggrégats
  public customTotalMeasure: string = null;

  // conf complémentaire (settings sur workflow)
  public moreSettings: string = null;

  /** sur séquence de démarrage, alimentation des données */
  public feed(): void {
    
    // titre de la popUp
    this.titleLabel = this.model.feiEngine.getFeiKeyDefTechnicalLabel(this.datas.pivotField.fkd);

    // formule en cas de mesure
    if (this.datas.pivotField.fkd.isMeasure) {
      let formula: string = this.datas.pivotField.fkd.measure['formula' + this.datas.pivotField.mode]; // formule du champ
      let desc: string = this.model.measureEngine.getMeasureDescription(this.datas.pivotField.fkd.measure);
         
      this.contentLabel = desc;
      this.contentLabel += '<br>' + formula;

    }

    // libellé custom pour la colonne
    this.customHeaderTitle = this.datas.pivotField.labelOrDefaultLabel;
    // masquer le filtre
    this.hideFilter = this.datas.pivotField.filtHide; 
    this.mandatoryFilter = this.datas.pivotField.mandatoryFilter;
    // afficher uniquement les valeurs dispo
    this.onlyExist = this.datas.pivotField.filtOnlyExist; 

    // gestion de la taille de colonne
    this.colWidth = this.datas.actualWidth || this.datas.pivotField.colSize; // On prend la largeur actuelle, sinon la largeur dans le champ de configuration
    this.colResize = this.datas.pivotField.colRezisable;
    this.colAuto = this.datas.pivotField.colAutoSize;
    this.colMinWidth = this.colResize ? this.datas.pivotField.colMinSize: null;
    this.exportable =  this.datas.pivotField.exportable;
    this.hidden =  this.datas.pivotField.hiddenCol;

    // gestion des groupes de colonnes
    if(this.datas.currentGroups?.length > 0) {
      this.groupDS.setSource(this.datas.currentGroups); 
      let initPiv: PivotField = null;
      if (!!this.datas.pivotField.parentGroup) {
        this.groupDS.getSource().forEach((pf: PivotField) => {
          if (this.datas.pivotField.parentGroup === pf.fkd.code) {
            initPiv = pf;
          }
        });
      }
      this.groupDS.select([initPiv]);
    }

    // gestion du style
    let style: StyleVO = null; // le style
    let styleSplit: string[] = null;
    if (this.datas.pivotField.style) {
      styleSplit = this.datas.pivotField.style.split(ViewData.KEY_SEPARATOR);
      style = this.model.styleEngine.getStyle(styleSplit[0], styleSplit[1]);
    } else if (!!this.datas.pivotField.fkd.defaultStyle) {
      styleSplit = this.datas.pivotField.fkd.defaultStyle.split(ViewData.KEY_SEPARATOR);
      style = this.model.styleEngine.getStyle(styleSplit[0], styleSplit[1]);
    }
    this.styleDS.select([style]);

    let cssstyle: CssRenderVO = null; // le style 
    if (this.datas.pivotField.style) {
      cssstyle = this.cssStyleDS.getItemByKey(this.datas.pivotField.style);
    }
    this.cssStyleDS.select([cssstyle]);
    // if(!!this.ddCssStyle) {
    //   this.ddCssStyle.wizDataProvider = this.cssStyleDS;
    // }


    // gestion du style pour les lignes de conso
    let styleConso: StyleVO = null; // le style
    let styleConsoSplit: string[] = null;
    if (this.datas.pivotField.styleConso) {
      styleConsoSplit = this.datas.pivotField.styleConso.split(ViewData.KEY_SEPARATOR);
      styleConso = this.model.styleEngine.getStyle(styleConsoSplit[0], styleConsoSplit[1]);
    } 
    this.styleDSConso.select([styleConso]);



    // gestion du rendu du header, alimentation font & background
    if (!!this.datas.pivotField.headerStyle) {
      const styleParts: string[] = this.datas.pivotField.headerStyle.split(ViewData.KEY_SEPARATOR);
      if (!!styleParts[0]) {
        this.backgroundColor = styleParts[0];
      }
      if (!!styleParts[1]) {
        this.fontColor = styleParts[1];
      }
    }
    this.headColorField = this.datas.pivotField.headColorField;
    this.headSubField = this.datas.pivotField.headSubField;
    this.headInherit = this.datas.pivotField.headInherit;

    // style par mesures pour les timelines
    if (!!this.datas.pivotField.measureStyle) {
      const styleParts: string[] = this.datas.pivotField.measureStyle.split(ViewData.KEY_SEPARATOR);
      if (!!styleParts[0]) {
        this.fontMeasure = styleParts[0];
      }
      if (!!styleParts[1]) {
        this.backMeasure = styleParts[1];
      }
    }

    // construction du CSS actif pour les colonnes
    const parts: string[] = [];
    parts.push(StyleEngine.STYLE_FONT_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.fontColor);
    parts.push(StyleEngine.STYLE_BACKGROUND_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.backgroundColor);
    this.css = parts.join(ViewData.STYLE_ELEMENT_SEPARATOR);
    
    // gestion du rendu des cellules, alimentation font & background
    if (!!this.datas.pivotField.cellStyle) {
      const styleParts: string[] = this.datas.pivotField.cellStyle.split(ViewData.KEY_SEPARATOR);
      if (!!styleParts[0]) {
        this.cellBackgroundColor = styleParts[0];
      }
      if (!!styleParts[1]) {
        this.cellFontColor = styleParts[1];
      }
      if (!!styleParts[2]) {
        this.isBold = styleParts[2] === 'bold';
      }
    }

    // construction du CSS actif pour les cellules
    const cellParts: string[] = [];
    cellParts.push(StyleEngine.STYLE_FONT_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.cellFontColor);
    cellParts.push(StyleEngine.STYLE_BACKGROUND_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.cellBackgroundColor);
     if(this.isBold) {
      cellParts.push(StyleEngine.STYLE_FONT_WEIGHT + ViewData.KEY_PAIR_SEPARATOR + "bold");
    }
    
    this.cellCss = cellParts.join(ViewData.STYLE_ELEMENT_SEPARATOR);

    // gestion du groupe de colonne
    const func: string = this.datas.pivotField.aggOrDefaultFunc();
    this.functionDS.refresh();
    this.functionDS.select([this.functionDS.getItemByKey(func)]);
 
    // gestion du groupe de colonne sur cumul
    const totfunc: string = this.datas.pivotField.totalAgregateFunc || this.datas.pivotField.aggOrDefaultFunc();
    this.totalFunctionDS.refresh();
    this.totalFunctionDS.select([this.totalFunctionDS.getItemByKey(totfunc)]);
 
    this.customTotalMeasure = this.datas.pivotField.totalAgregateMeasure;


    // gestion du format
    this.formatDS.refresh(); // actualisation de la drop des formats
    let format: FormatVO = null; // le format de données
    let formatSplit: string[] = null;
    if (this.datas.pivotField.format) {
      formatSplit = this.datas.pivotField.format.split(ViewData.KEY_SEPARATOR);
      format = this.model.formatEngine.getFormat(formatSplit[0], formatSplit[1]);
    } else if (!!this.datas.pivotField.fkd.defaultFormat) {
      formatSplit = this.datas.pivotField.fkd.defaultFormat.split(ViewData.KEY_SEPARATOR);
      format = this.model.formatEngine.getFormat(formatSplit[0], formatSplit[1]);
    }
    this.formatDS.select([format]);

    // gestion du format sur cumul
    this.totalFormatDS.refresh(); // actualisation de la drop des formats
    let totalformat: FormatVO = null; // le format de données
    let totalformatSplit: string[] = null;
    if (this.datas.pivotField.totalFormat) {
      totalformatSplit = this.datas.pivotField.totalFormat.split(ViewData.KEY_SEPARATOR);
      totalformat = this.model.formatEngine.getFormat(totalformatSplit[0], totalformatSplit[1]);
    } else if (!!this.datas.pivotField.fkd.defaultFormat) {
      totalformatSplit = this.datas.pivotField.fkd.defaultFormat.split(ViewData.KEY_SEPARATOR);
      totalformat = this.model.formatEngine.getFormat(totalformatSplit[0], totalformatSplit[1]);
    }
    this.totalFormatDS.select([totalformat]);


    // gestion de l'alignement des headers
    let headerAlign: FakeVO = null; // le format de données
    let ha: string = this.datas.pivotField.headerAlign;
    headerAlign = this.headerAlignDS.getItemByKey(ha);
    this.headerAlignDS.select([headerAlign]);

    this.readOnly = this.datas.pivotField.readOnly;
    this.massEditSplit = this.datas.pivotField.massSplit;

    if(this.datas.pivotField.fkd.isFreedata) {
      // gestion du field des FDVs
      const argSrc: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(this.datas.pivotField.fkd.code);
      this.fieldDS.setSource(argSrc ? [...argSrc] : []);

      let field: FreedataArgsVO = null; // le champ de FDVs
      if (this.datas.pivotField.fdvField) {
        field = this.fieldDS.getItemByKey(this.datas.pivotField.fdvField);
      }
      this.fieldDS.select([field]);
    } else if (this.datas.pivotField.fkd.isChrono) {
      
      let field: FakeVO = null; // le champ de chrono
      if (this.datas.pivotField.fdvField) {
        field = this.chronoFieldDS.getItemByKey(this.datas.pivotField.fdvField);
        // console.log('head field', field);
      } 
      this.chronoFieldDS.select([field]);
    }
    

    if (!!this.datas.pivotField.fdvSearch) { // champs sélectionné pour rendu des pops de sélection
      this.searchFields = this.datas.pivotField.fdvSearch.split(ViewData.KEY_SEPARATOR);
    }

    this.resetSubFields(); // construction de la collection de subFields pour rendu pop

    // trier fieldsDS par fdvSearch
    if (!!this.searchFields && this.searchFields.length > 0) { // champs sélectionné pour rendu des pops de sélection
      const valArgs: FreedataArgsVO[] = this.searchFields.map(item => this.fieldsDS.getItemByKey(item));
      this.fieldsDS.select(valArgs);
      this.fieldsDS.doSort(this.fieldsDS.getSource()); // on ré-applique le tri
    } 

    // gestion des settings sur workflow
    this.moreSettings = this.datas.pivotField.pmdexParams;
  }
  
  /** gestion de la visibilité des zones de configuration, selon le widget et sa conf */
  public manageVisibility(): void {
    
    //##########
    //### gestion du rendu d'entête
    //##########
    // alignement
    let useHeaderTextAlign: boolean = false;
    // colonnes dimensionnables
    let useColumn: boolean = false;
    // styles des headers
    let useHeaderColors: boolean = false;
    // field de styles des headers
    let usePivotHeaderColors: boolean = false;
    // héritage des style de la colonne parente
    let useHeaderInherit: boolean = false;


    if(this.datas.widget.widgetKind === WIDGET_KIND.GRID || this.datas.widget.widgetKind === WIDGET_KIND.PIVOT
      || this.datas.widget.widgetKind === WIDGET_KIND.FORM // valable pour les subGrids
    ) {
      if(!this.datas.baseCollector || // directement depuis une colonne
      this.datas.baseCollector.id === 'lstData' || 
      this.datas.baseCollector.id === 'lstRow' ) {
        useHeaderTextAlign = true;
        useColumn = true;
        useHeaderColors = true;
        useHeaderInherit = true;
      } else if(this.datas.baseCollector.id === 'lstColumn') {
        useHeaderTextAlign = true;
        useColumn = true; // pour taille du pivot.revert
        useHeaderColors = true;
        usePivotHeaderColors = true;
      }
    }


    //### gestion du style sur les filtres
    this.useCssStyle = true;
    
    if ( (this.datas.popUpMode === WIDGET_KIND.PIVOT || 
          this.datas.popUpMode === WIDGET_KIND.TILE ||
          this.datas.popUpMode === WIDGET_KIND.GLOBAL_FILTER ||
          this.datas.popUpMode === WIDGET_KIND.GRID) && // pivot ou grid
         this.datas.baseCollector?.id === 'lstFilter') { // uniquement pour row & data
      useColumn = true;
      this.isFilter = true;
      // console.log("where", this.datas.popUpMode, this.datas.baseCollector?.id);
    } 

    this.useHeaderTextAlign = useHeaderTextAlign;
    this.useColumn = useColumn;
    this.useHeaderColors = useHeaderColors;
    this.usePivotHeaderColors = usePivotHeaderColors;
    this.useHeaderInherit = useHeaderInherit;

    // groupe de colonnes custom
    let useHeaderGroup: boolean = false;
    if (this.datas.widget.widgetKind === WIDGET_KIND.PIVOT && // les grids se présentent comme des pivots
      // this.datas.widget.pivotMode === false && 
      (this.datas.baseCollector?.id === 'lstRow' ||
      this.datas.baseCollector?.id === 'lstData') &&
      this.datas.currentGroups?.length > 0) {
        useHeaderGroup = true;
    }
    this.useHeaderGroup = useHeaderGroup;

    //##########
    //### gestion du contenu
    //##########

    // gestion du lecture seule
    let useFormatReadonly = false;
    if (
      (this.datas.popUpMode === WIDGET_KIND.PIVOT || this.datas.popUpMode === WIDGET_KIND.GRID) 
        && (this.datas.baseCollector?.id === 'lstData' || this.datas.place === 'data')
        && (this.datas.pivotField.isI || this.datas.pivotField.fkd?.isFilterKey) // mesure potentiellement éditable
    ) {
      useFormatReadonly = true;
    }
    this.useFormatReadonly = useFormatReadonly;

    // gestion du massEdit en mode split
    let useMassEditSplit = false;
    if (
      (this.datas.popUpMode === WIDGET_KIND.PIVOT || this.datas.popUpMode === WIDGET_KIND.GRID) 
        && (this.datas.baseCollector?.id === 'lstData' || this.datas.baseCollector?.id === 'lstRow'
        || this.datas.place === 'data' || this.datas.place === 'row')
        && this.datas.pivotField.fkd?.editable // mesure éditable
        && this.datas.widget?.context?.hme
    ) {
      useMassEditSplit = true;
    }
    this.useMassEditSplit = useMassEditSplit;

    // gestion des champs FDV / Chrono
    let useKey = false;
    // champ de FDV
    let useFormatField = false;
    // champ de chrono
    let useFormatChronoField = false;
    
    // choix du label sur les FDVs
    if (!!this.datas.pivotField.fkd.isFreedata) {
      useFormatField = true;
    }
    this.useFormatField = useFormatField;
    // choix du label sur les chronos
    if (!!this.datas.pivotField.fkd.isChrono) {
      useFormatChronoField = true;
    }
    this.useFormatChronoField = useFormatChronoField;
    this.useKey = useFormatField || useFormatChronoField;

    if (this.datas.baseCollector?.id === 'lstFilter') { // mode édition des filtres: libellé et masqué
      this.useHeaderHideFilter = true;
      if(this.datas.popUpMode !== WIDGET_KIND.GLOBAL_FILTER) { // pas de restriction sur globalFilter)
        this.useHeaderOnlyExist = true;
      } 
    } else { // pas les filtres, on peut choisir les couleurs de header
      // this.useHeaderTextAlign = true;
      // this.useHeaderColors = true;
    }

    //### gestion du format
    // this.realHeight += this.formatHeight;
    // console.log('useFormat', this.realHeight);
    // gestion de la fonction d'aggrégat, sur les pivots ou en mode liste
    if (
      (this.datas.popUpMode === WIDGET_KIND.PIVOT || 
        this.datas.popUpMode === WIDGET_KIND.LIST || 
        this.datas.popUpMode === WIDGET_KIND.FORM || 
        this.datas.popUpMode === WIDGET_KIND.CHART) 
        && (this.datas.baseCollector?.id === 'lstData' || this.datas.place === 'data')
        && this.datas.widget?.pivotMode === true
        && !this.datas.widget?.context?.pmd
      ) {
        this.useAggregate = true;
    } 

    // pas de format pour les timelines
    if(this.datas.popUpMode === WIDGET_KIND.TIMELINE ) {
        this.useFormat = false;
    } 


    //### gestion du style
    if ( (this.datas.popUpMode === WIDGET_KIND.PIVOT || 
          this.datas.popUpMode === WIDGET_KIND.GRID ||
          this.datas.popUpMode === WIDGET_KIND.CALENDAR ||
          this.datas.popUpMode === WIDGET_KIND.TIMELINE) && // pivot ou grid
         (!this.datas.baseCollector ||
          this.datas.baseCollector.id === 'lstData' ||
          this.datas.baseCollector.id === 'lstRow')) { // uniquement pour row & data
      this.useStyle = true;
      if ( (this.datas.popUpMode === WIDGET_KIND.TIMELINE || this.datas.popUpMode === WIDGET_KIND.CALENDAR) && this.datas.baseCollector?.id === 'lstData') {
        this.useStyleMeasure = true;
      }
      // this.realHeight += this.styleHeight;
      // console.log('useStyle', this.realHeight);
    } 

    // visible dans les filtres
    // visibles pour les FilterKey en row / data pour les baselines
    // visible pour le globalFilter (juste filtre)

    let useSearchFields: boolean = false;

    if (this.datas.pivotField.fkd?.isKey && this.datas.pivotField.fkd?.isFreedata) { // il faut que ce soit une clé
      // if (this.datas.popUpMode === WIDGET_KIND.GLOBAL_FILTER) { // filtre global
      //   useSearchFields = true;
      // } else 
      if(this.datas.baseCollector?.id === 'lstFilter') { // en filter, OK
        if(this.datas.widget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.BASELINE) {
          useSearchFields = true;
        } else if(this.datas.widget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.FREEDATA &&
          this.arg?.dataType === FIELD_KIND.OBJECT) {
            useSearchFields = true;
        }

      } else if(this.datas.widget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.BASELINE
        && this.datas.pivotField.fkd?.isFilterKey) { // un widget baseline en filterKey
        useSearchFields = true;
      }
    }

    if(useSearchFields) {
      this.useSearchFields = true;
    } else {
      this.useSearchFields = false;
    }
  }

  /** définition de la bonne taille */
  // protected getMyRealSize(): void {
  //   if (this.realHeight !== HeaderEditExtPop.baseHeight) {
  //     // console.log("delta size", this.realHeight);
  //     this.datas.popReference.dialogRef.updateSize(HeaderEditExtPop.baseWidth + 'px', this.realHeight + 'px');
  //   }
  // }

  protected resetTotalSubFields(): void {
    let newDatakind: string = this.datas.pivotField.fkd?.datakind;
    if(this.totalFunctionDS.selectedItem) { // on a choisi une méthode d'aggrégat
      if(this.totalFunctionDS.selectedItem.dataKind) {
        newDatakind = this.totalFunctionDS.selectedItem.dataKind;
      }
    }

    // clean éventuel de la drop des formats
    if(this.totalFormatDS.selectedItem && this.totalFormatDS.selectedItem.dataKind !== newDatakind) {
      this.totalFormatDS.clearSelection();
    } 
    this.totalFormatDS.refresh();

  }
    
  protected resetSubFields(): void {
    
    let newDatakind: string = this.datas.pivotField.fkd?.datakind;
    
    if(this.datas.pivotField.fkd.isFreedata) { // changement de champ sur un FDV
      const field: FreedataArgsVO = this.fieldDS.selectedItem; // le champ de FDVs
      if (!!field && field.dataType === FIELD_KIND.OBJECT) { // un champ custom est sélectionné. Si c'est un objet, c'est lui qui donne le contenu des champs de pops
      const subArgSrc: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(field.datas.split(ViewData.CONTEXT_SEPARATOR)[0]);
      this.fieldsDS.setSource(subArgSrc ? [...subArgSrc] : []);
     } else {
      const argSrc: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(this.datas.pivotField.fkd.code);
      this.fieldsDS.setSource(argSrc ? [...argSrc] : []);
     }
     newDatakind = field?.dataType || null;

    //  if(this.formatDS.selectedItem && this.formatDS.selectedItem.dataKind !==  field?.dataType) {
    //   this.formatDS.clearSelection();
    //  } 

    } else if(this.datas.pivotField.fkd.isChrono) { // changement de champ sur un chrono
      const fake: FakeVO = this.model.chronocodeEngine.getChronoFieldByCode(this.chronoFieldDS.selectedItem?.code);
      newDatakind = fake?.datakind || null;
      // if(this.formatDS.selectedItem && this.formatDS.selectedItem.dataKind !==  fake?.datakind) {
      //   this.formatDS.clearSelection();
      // } 
    }

    if(this.useAggregate && this.functionDS.selectedItem) { // on a choisi une méthode d'aggrégat, elle domine
      if(this.functionDS.selectedItem.dataKind) {
        newDatakind = this.functionDS.selectedItem.dataKind;
      }
    }

    // clean éventuel de la drop des formats
    if(this.formatDS.selectedItem && this.formatDS.selectedItem.dataKind !== newDatakind) {
      this.formatDS.clearSelection();
    } 

    this.formatDS.refresh();
  }


  /** mise en place des écouteurs */
  public addListeners(): void {
    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);
    WizEventManager.addListener(this, this.tabBar, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.clicOnTab); // écoute sélection d'un onglet
  }

  /**
   * Modification du model dans la zone de saisie
   * @param e Evenement model change
   */
  private updateModel(e: WizEvent): void {
    // console.log('updateModel', e.value, e.component);
    switch (e.component.id) {
      case 'tiLabel':
        this.clone.label = e.value;
        break;
      case 'cbHideFilter':
        this.clone.filtHide = e.value === '1' ? true : false;
        break;
      case 'cbMandatoryFilter':
        this.clone.mandatoryFilter = e.value === '1' ? true : false;
        break;  
      case 'cbExistValueFilter':
        this.clone.filtOnlyExist = e.value === '1' ? true : false;
        break;
      case 'ddField':
        this.clone.fdvField = this.fieldDS.selectedItem?.code || null;
        this.resetSubFields();
        break;
      case 'ddSubField':
        this.clone.fdvSubField = this.subFieldDS?.selectedItem?.code || null;
        this.resetSubFields();
        break;
      case 'ddChronoField':
        this.resetSubFields();
        break;
      case 'cbColResize': 
      this.clone.colRezisable = e.value === '1' ? true : false;
      this.checkSize();
        break;
      case 'cbColAuto': 
        this.clone.colAutoSize = e.value === '1' ? true : false;
        break;        
      case 'cbHidden': 
      this.clone.hiddenCol = e.value === '1' ? true : false;
        break;           
      case 'cbExport': 
      this.clone.exportable = e.value === '1' ? true : false;
        break;        
      case 'niColMinWidth': 
      this.clone.colMinSize = Number(e.value);
      this.checkSize();
        break;
      case 'niColWidth': 
      this.clone.colSize = Number(e.value);
      this.checkSize();
        break;
      case 'cbReadOnly':
        this.clone.readOnly = e.value === '1' ? true : false;
        break;
      case 'cbMassSplit':
        this.clone.massSplit = e.value === '1' ? true : false;
        break;
      case 'ddFunc':
        this.clone.wizAgregateFunc = this.functionDS.selectedItem?.code || null;
        this.resetSubFields();
        break;
      case 'ddTotalFunc':
        this.clone.totalAgregateFunc = this.totalFormatDS.selectedItem?.code || null;
        this.resetTotalSubFields();
        break;
      case 'totalMeasure':
        this.clone.totalAgregateMeasure = e.value;
        this.resetTotalSubFields();
        break;        
      case 'tiFontMeasure':
        this.styleMeasurePart('tiFontMeasure', e.value);
        break;
      case 'tiBackMeasure':
        this.styleMeasurePart('tiBackMeasure', e.value);
        break;
      case 'cbBold':
        this.isBold = e.value;
        this.feedHeaderStyle();
        break;
      case 'tiHeadColorField':
        this.clone.headColorField = e.value;
        break;
      case 'tiHeadSub':
        this.clone.headSubField = e.value;
        break;
      case 'cbHeadInherit':
        this.clone.headInherit = e.value === '1' ? true : false;
        break;
      case 'taSettings':
        this.clone.pmdexParams = e.value;
        break;
    }
    // console.log('fi', this.clone.formulaI);
    this.manageVisibility();
  }

  private styleMeasurePart(from: string, value: string): void {
    let parts: string[] = this.clone.measureStyle?.split(ViewData.KEY_SEPARATOR)|| [];
    while(parts.length < 2) {
      parts.push(null);
    }
    if(from === 'tiFontMeasure') {
        parts[0] = value;
    }    
    if(from === 'tiBackMeasure') {
        parts[1] = value;
    }
    this.clone.measureStyle = parts.join(ViewData.KEY_SEPARATOR);
  }

  /** contrôle de cohérence size / minSize */
  // TODO ajouter event + validator + check sur demande de validation
  private checkSize(): void {
    if(!this.clone.colRezisable) {
      this.clone.colMinSize = null;
      this.colMinWidth = null;
    }
    if(this.clone.colSize < this.clone.colMinSize) {
      this.clone.colSize = this.clone.colMinSize;
    }
    this.colMinWidth = this.clone.colMinSize;
    this.colWidth = this.clone.colSize;

    this.cdref.markForCheck();
  }

  /* ##############################################################################
                   FilterFuncs pour les DS
     ############################################################################## */

  /**
   * filterFunc de la liste de fonction d'aggrégat, selon le type de la données
   * @param e la fonction
   */
  public dataKindFilter(e: PivotFunction): boolean {
    let result: boolean = false;
    if (!this.datas?.pivotField?.fkd) {
      return false;
    }
    switch (this.datas.pivotField.fkd.datakind) {
      case FIELD_KIND.INT:
      case FIELD_KIND.NUMBER:
      case FIELD_KIND.CONSTANT:
        result = e.forNum;
        break;
      case FIELD_KIND.DATE:
        // console.log('this data', this.datas);
        result = e.forDate;
        break;
      case FIELD_KIND.BOOLEAN:
        result = e.forBoolean;
        break;
      case FIELD_KIND.COLOR:
        result = e.forColor;
        break;
      case FIELD_KIND.STRING:
        result = e.forString;
        break;
      default:
        result = e.forString;
        break;
    }
    return result;
  }

  /**
   * filterFunc de la liste des formats, selon le type de la données
   * @param e la fonction
   */
  public dataFormatFilter(fm: FormatVO): boolean {
    if (!this.datas?.pivotField?.fkd?.datakind) {
      return false;
    }

    // type, par défaut celui du fkd
    let targetDatakind: string = this.datas.pivotField.fkd.datakind;

    // override en cas de sélection d'aggrégat
    if(this.useAggregate && !!this.functionDS.selectedItem) {
      if(this.functionDS.selectedItem.dataKind) {
        targetDatakind = this.functionDS.selectedItem.dataKind;
      }
      // targetDatakind = this.functionDS.selectedItem.dataKind;
    } else { // un FDV ou un chrono
      if(this.datas.pivotField.fkd.isFreedata && this.fieldDS.selectedItem) {
        targetDatakind = this.fieldDS.selectedItem.dataType;
      } else if (this.datas.pivotField.fkd.isChrono && this.chronoFieldDS.selectedItem) {
        targetDatakind = this.chronoFieldDS.selectedItem.datakind;
      }
    }
    // console.log('filter format',this.datas.pivotField.pkd.dataKind, this.datas.pivotField.fdvField);
    return fm.dataKind === targetDatakind;
  }

  /* ##############################################################################
                   FilterFuncs pour les DS des TOTAUX
     ############################################################################## */

  /**
   * filterFunc de la liste de fonction d'aggrégat, selon le type de la données
   * @param e la fonction
   */
  public totalDataKindFilter(e: PivotFunction): boolean {
    let result: boolean = false;
    if (!this.datas?.pivotField?.fkd) {
      return false;
    }
    switch (this.datas.pivotField.fkd.datakind) {
      case FIELD_KIND.INT:
      case FIELD_KIND.NUMBER:
      case FIELD_KIND.CONSTANT:
        result = e.forNum;
        break;
      case FIELD_KIND.DATE:
        // console.log('this data', this.datas);
        result = e.forDate;
        break;
      case FIELD_KIND.BOOLEAN:
        result = e.forBoolean;
        break;
      case FIELD_KIND.COLOR:
        result = e.forColor;
        break;
      case FIELD_KIND.STRING:
        result = e.forString;
        break;
      default:
        result = e.forString;
        break;
    }
    return result;
  }

  /**
   * filterFunc de la liste des formats, selon le type de la données
   * @param e la fonction
   */
  public totalDataFormatFilter(fm: FormatVO): boolean {
    if (!this.datas?.pivotField?.fkd?.datakind) {
      return false;
    }

    let targetDatakind: string = this.datas.pivotField.fkd.datakind;

    // override en cas de sélection d'aggrégat
    if(!!this.totalFunctionDS.selectedItem) {
      if(this.totalFunctionDS.selectedItem.dataKind) {
        targetDatakind = this.totalFunctionDS.selectedItem.dataKind;
      }    
    } else { // un FDV ou un chrono
      if(this.datas.pivotField.fkd.isFreedata && this.fieldDS.selectedItem) {
        targetDatakind = this.fieldDS.selectedItem.dataType;
      } else if (this.datas.pivotField.fkd.isChrono && this.chronoFieldDS.selectedItem) {
        targetDatakind = this.chronoFieldDS.selectedItem.datakind;
      }
    }
    // console.log('filter format',this.datas.pivotField.pkd.dataKind, this.datas.pivotField.fdvField);
    return fm.dataKind === targetDatakind;
  }


  /* ##############################################################################
                   sauvegarde
     ############################################################################## */

  /** Sauvegarde */
  public save(): void {
    // validation du container pour contrôle de cohérence de la zone formule & aggFunc mandatory
    if(!!this.gpColumnValidator) {
      const errors: WizValidationError[] = this.gpColumnValidator.check();
      if (errors && errors.length > 0) {
        console.log('cols errors', errors);
      } else {
        this.hide();
      }
    } else {
      this.hide();
    }
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  /** sur hide, tentative d'enregistrement */
  public onHide() {
    if (this.doSaveFlag) {
      this.datas.pivotField.wizAgregateFunc = this.functionDS?.selectedItem ? this.functionDS.selectedItem.code : null;

      // style par rendu css
      this.datas.pivotField.style = null;
      if(this.useCssStyle) {
        const style: CssRenderVO = this.cssStyleDS.selectedItem;
        const styleCode: string = style ? style.code : null;
        this.datas.pivotField.style = styleCode;
      }

      // style AKM
      if(this.useStyle) {
        const style: StyleVO = this.styleDS.selectedItem;
        const styleCode: string = style ? style.visionCode + ViewData.KEY_SEPARATOR + style.code : null;
        if(styleCode) {
          this.datas.pivotField.style = styleCode;
        }
      } 

      // const style: StyleVO = this.styleDS.selectedItem;
      // const styleCode: string = style ? style.visionCode + ViewData.KEY_SEPARATOR + style.code : null;
      // this.datas.pivotField.style = styleCode;



      const styleConso: StyleVO = this.styleDSConso.selectedItem;
      const styleConsoCode: string = styleConso ? styleConso.visionCode + ViewData.KEY_SEPARATOR + styleConso.code : null;
      this.datas.pivotField.styleConso = styleConsoCode;

      const format: FormatVO = this.formatDS.selectedItem;
      const formatCode: string = format ? format.businessUnitCode + ViewData.KEY_SEPARATOR + format.code : null;
      this.datas.pivotField.format = formatCode;

      if(this.datas.pivotField.fkd.isFreedata) {
        const fdvField: FreedataArgsVO = this.fieldDS.selectedItem;
        this.datas.pivotField.fdvField = fdvField ? fdvField.code : null;

        const fdvSubField: FreedataArgsVO = this.subFieldDS.selectedItem;
        this.datas.pivotField.fdvSubField = fdvSubField ? fdvSubField.code : null;

      } else if(this.datas.pivotField.fkd.isChrono) {
        const field: FakeVO = this.chronoFieldDS.selectedItem;
        this.datas.pivotField.fdvField = field ? field.code : null;
      }  

      this.datas.pivotField.totalAgregateFunc = this.totalFunctionDS?.selectedItem ? this.totalFunctionDS.selectedItem.code : null;
      this.datas.pivotField.totalAgregateMeasure = this.clone.totalAgregateMeasure;
      const totalformat: FormatVO = this.totalFormatDS.selectedItem;
      const totalFormatCode: string = totalformat ? totalformat.businessUnitCode + ViewData.KEY_SEPARATOR + totalformat.code : null;
      this.datas.pivotField.totalFormat = totalFormatCode;



      let fdvSearch: string = null;
      if (this.fieldsDS.selectedItems) {
        const parts: Set<string> = new Set();

        this.fieldsDS.selectedItems.forEach(item=> {
          if(!!item) {
            parts.add(item.code);
          }
        });
        const orderedParts: string[] = []; // on les prend dans le bon ordre
        this.fieldsDS.getWorkedSource().forEach((arg: FreedataArgsVO) => {
          if(parts.has(arg.code)) {
            orderedParts.push(arg.code);
          }
        });

        // console.log('parts', parts, orderedParts);
        fdvSearch = orderedParts?.join(ViewData.KEY_SEPARATOR) || null;
      }
      this.datas.pivotField.fdvSearch = fdvSearch;


      this.datas.pivotField.label = this.clone.label;
      this.datas.pivotField.filtHide = this.clone.filtHide ? true: false;
      this.datas.pivotField.mandatoryFilter = this.clone.mandatoryFilter ? true: false;
      this.datas.pivotField.filtOnlyExist = this.clone.filtOnlyExist ? true: false;
      this.datas.pivotField.headerStyle = this.backgroundColor + ViewData.KEY_SEPARATOR + this.fontColor;
      this.datas.pivotField.headColorField = this.clone.headColorField;
      this.datas.pivotField.headSubField = this.clone.headSubField;
      this.datas.pivotField.headInherit = this.clone.headInherit;
      

      let bold: string = this.isBold ? 'bold' : null;
      this.datas.pivotField.cellStyle = this.cellBackgroundColor + ViewData.KEY_SEPARATOR + this.cellFontColor + ViewData.KEY_SEPARATOR + bold;
      
      this.datas.pivotField.measureStyle = this.clone.measureStyle;
      
      this.datas.pivotField.colRezisable = this.clone.colRezisable ? true: false;
      this.datas.pivotField.colAutoSize = this.clone.colAutoSize ? true: false;
      this.datas.pivotField.colMinSize = this.clone.colMinSize;
      this.datas.pivotField.colSize = this.clone.colSize;
      this.datas.pivotField.exportable = this.clone.exportable ? true: false;
      this.datas.pivotField.hiddenCol = this.clone.hiddenCol ? true: false;

      this.datas.pivotField.readOnly = this.clone.readOnly ? true: false;
      this.datas.pivotField.massSplit = this.clone.massSplit ? true: false;
      this.datas.pivotField.parentGroup = !!this.groupDS.selectedItem ? this.groupDS.selectedItem.fkd.code : null;

      this.datas.pivotField.headerAlign = !!this.headerAlignDS.selectedItem ? this.headerAlignDS.selectedItem.code : null;
      // this.datas.pivotField.cellAlign = !!this.cellAlignDS.selectedItem ? this.cellAlignDS.selectedItem.code : null;

      this.datas.pivotField.pmdexParams = this.clone.pmdexParams || null;

      this.datas.updateCallback(this.datas.baseCollector, this.datas.pivotField);
    }
  }

  /* ##############################################################################
                   gestion du colorPicker pour la conf du header
     ############################################################################## */

  /**
   * affichage de la popUp du colorPicker
   * @param pEvent click
   */
  public showColorPicker(pEvent: Event): void {
    let targetColor = null;
    if (pEvent.target === this.blockFont?.nativeElement) {
      targetColor = this.fontColor;
    } else if (pEvent.target === this.blockBack?.nativeElement) {
      targetColor = this.backgroundColor;
    } else if (pEvent.target === this.cellBlockFont?.nativeElement) {
      targetColor = this.cellFontColor;
    } else if (pEvent.target === this.cellBlockBack?.nativeElement) {
      targetColor = this.cellBackgroundColor;
    }
    pEvent.stopPropagation();
    pEvent.preventDefault();
    ColorPickerPop.show(pEvent.target as HTMLElement, pEvent.target, targetColor, this.backFromPicker.bind(this));
  }

  /**
   * retour de colorPicker, alimentation des couleurs du header
   *
   * @param target le span source pour font ou background
   * @param color la couleur du picker
   */
  public backFromPicker(target: any, color: string): void {
    if (target === this.blockFont?.nativeElement) {
      this.fontColor = color;
    } else if (target === this.blockBack?.nativeElement) {
      this.backgroundColor = color;
    } else if (target === this.cellBlockFont?.nativeElement) {
      this.cellFontColor = color;
    } else if (target === this.cellBlockBack?.nativeElement) {
      this.cellBackgroundColor = color;
    }
    this.feedHeaderStyle();
  }

  /** alimentation des slots de couleurs pour le header */
  public feedHeaderStyle(): void {
    const parts: string[] = [];
    parts.push(StyleEngine.STYLE_FONT_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.fontColor);
    parts.push(StyleEngine.STYLE_BACKGROUND_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.backgroundColor);

    this.css = parts.join(ViewData.STYLE_ELEMENT_SEPARATOR);

    // style des cellules
    const parts2: string[] = [];
    parts2.push(StyleEngine.STYLE_FONT_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.cellFontColor);
    parts2.push(StyleEngine.STYLE_BACKGROUND_COLOR + ViewData.KEY_PAIR_SEPARATOR + this.cellBackgroundColor);
    if(this.isBold) {
      parts2.push(StyleEngine.STYLE_FONT_WEIGHT + ViewData.KEY_PAIR_SEPARATOR + "'bold'");
    }
    
    this.cellCss = parts2.join(ViewData.STYLE_ELEMENT_SEPARATOR);

    this.cdref.markForCheck();
  }

  /** click sur les icones de suppression de style de header */
  public resetColor(who: string): void {
    if (who === 'blockFont') {
      this.fontColor = 'unset'; // StyleEngine.STYLE_DEFAULT_FONT_COLOR; // --grid-header-color
    } else if (who === 'blockBack') {
      this.backgroundColor = 'unset'; // StyleEngine.STYLE_DEFAULT_CELL_BACKGROUND_COLOR; // StyleEngine.STYLE_DEFAULT_BACKGROUND_COLOR; // --grid-header-background-color
    } else if (who === 'cellBlockFont') {
      this.cellFontColor = StyleEngine.STYLE_DEFAULT_CELL_FONT_COLOR; // --grid-header-color
    } else {
      this.cellBackgroundColor = StyleEngine.STYLE_DEFAULT_CELL_BACKGROUND_COLOR; // --grid-header-background-color
    }
    this.feedHeaderStyle();
  }

  /* ##############################################################################
                  gestion du style
    ############################################################################## */

  /** clic sur Bt édition du style en cours */
  public editStyle(): void {
    this.showStylePop(this.ddStyle.selectedItem);
  }

  /** création d'un nouveau style */
  public addStyle(): void {
    this.showStylePop(null);
  }

  /** ouverture de la popUp de configuration du style */
  private showStylePop(style: StyleVO): void {
    if (PopUpManager.exist(this.stylePop)) {
      // suppression de l'instance existante
      this.stylePop.hide();
    }
    // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    this.stylePop = new WizPopUp(
      HeaderEditStyleSubPop,
      false,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      '1000px',
      '350px',
      [this.model, style, this.backFromStylePop.bind(this)]
    ).show();
  }

  /**
   * modification du style conditionnel
   */
  public backFromStylePop(vo: StyleVO): void {
    // console.log('backfromstyle', vo);
    if (vo) {
      // pas de VO sur simple cancel
      const exist = this.styleDS.getItemByKey(vo.fullCode);
      if (!exist) {
        // c'est une création
        this.styleDS.addItem(vo);
        this.styleDS.select([vo]);
        this.ddStyle.wizDataProvider = this.styleDS;

        this.styleDSConso.addItem(vo);
        this.styleDSConso.select([vo]);
        this.ddStyleConso.wizDataProvider = this.styleDSConso;

      }
    }
  }

  /**
   * sort custom pour placer les searchFields sélectionnés en premier
   * @param itemA 
   * @param item 
   */
  public sortSelectedFirst(itemA: FreedataArgsVO, itemB: FreedataArgsVO): number {
    // console.log('sort', itemA, itemB, this.searchFields);
    let idxOfA: number = -1;
    let idxOfB: number = -1;
    if (this.searchFields) {
      idxOfA = this.searchFields.indexOf(itemA.code) >-1 ? this.searchFields.indexOf(itemA.code) : -1;
      idxOfB = this.searchFields.indexOf(itemB.code) >-1 ? this.searchFields.indexOf(itemB.code) : -1;
    }

    if (idxOfA === -1) {
      idxOfA = 1000 + itemA.order;
    }

    if (idxOfB  === -1) {
      idxOfB = 1000 + itemB.order;
    }

    let result: number = 1;
    if(idxOfB - idxOfA >= 0) {
      result = -1;
    }
    // console.log('##A',idxOfA, itemA.code, "##B",idxOfB, itemB.code, "##Res", result);
    return result;
  }

  /* ##############################################################################
          navigation
    ############################################################################## */

  public tabs: WizDatasource<WizActionObj> = null;

  /**
   * sur init, construction des tabs
   */
  private manageTabs(): void {
    // selon le type et la zone cible
    let tabs: WizActionObj[] = [];
    // toujours à minima le header
    tabs.push(new WizActionObj('headTab', null, null, WizTabButton, false, null, null, null, '$.conf.headers.$', {lineColor: '#d00000'}, false, false));
    
    
    if( // gestion du contenu
      !this.datas.baseCollector || // directement depuis une colonne
      (this.datas.baseCollector.id === 'lstData') || 
      this.datas.baseCollector.id === 'lstRow' || 
      this.datas.baseCollector.id === 'lstFilter' ||
      this.datas.baseCollector.id === 'lstColumn') 
    {
      tabs.push(new WizActionObj('contentTab', null, null, WizTabButton, false, null, null, null, '$.conf.content.$', {lineColor: '#00d0d0'}, false, false));   
    }
    // contenu pour style sur baseline.timeline
    // if(this.datas.baseCollector?.id === 'lstData' && this.datas.popUpMode === WIDGET_KIND.TIMELINE) {
    //   tabs.push(new WizActionObj('contentTab', null, null, WizTabButton, false, null, null, null, '$.conf.content.$', {lineColor: '#00d0d0'}, false, false));   
    // }

    // mode avancé (workflow), gestion des settings pour override de la mesure
    if(this.datas.pivotField?.fkd?.datakind === FIELD_KIND.WORKFLOW) {
     tabs.push(new WizActionObj('advancedTab', null, null, WizTabButton, false, null, null, null, '$.conf.advanced.$', {lineColor: '#ee22cc'}, false, false));
    }


    if (this.datas.baseCollector?.id === 'lstFilter' || // les zones de filtre
     (this.datas.widget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.BASELINE && 
      this.datas.pivotField.fkd?.isFilterKey) // et les filterKeys
    ) { // gestion des filtres
      tabs.push(new WizActionObj('filterTab', null, null, WizTabButton, false, null, null, null, '$.conf.filters.$', {lineColor: '#ee22cc'}, false, false));
    }

    if ((this.datas.widget.widgetKind === WIDGET_KIND.GRID || this.datas.widget.widgetKind === WIDGET_KIND.PIVOT)
        && (this.datas.baseCollector?.id === 'lstData' || this.datas.place === 'data')
        && (this.datas.widget?.context?.stot === true || this.datas.widget?.context?.pmd === true)
      ) {
      tabs.push(new WizActionObj('totalTab', null, null, WizTabButton, false, null, null, null, '$.conf.totals.$', {lineColor: '#ee22cc'}, false, false));
    }

    this.tabs = new WizDatasource<WizActionObj>(tabs).build();
    this.tabs.select([this.tabs.getSource()[0]]);
    // activation de la zone
    this.selectTab(this.tabs.getSource()[0].buttonCode);
  }


  isSelected(obj: WizActionObj): boolean {
    return this.tabs.isSelected(obj);
  }

  private clicOnTab(e: WizEvent): void {
    // console.log('clicOnTab', this.tabs.selectedItem);
    this.selectTab(this.tabs.selectedItem?.buttonCode);
  }

  private selectTab(who: string): void {
    this.headTab = false;
    this.contentTab = false;
    this.advancedTab = false;
    this.totalTab = false;
    this.filterTab = false;
    this[who] = true;
  }



}
